import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledClientTestimonials = styled(NanoFlex)`
  border-radius: 10px;
  overflow: hidden;
  height: auto;

  .purpleBlock {
    padding: 48px 100px 48px 100px;
    background: ${(props) => props.theme.color.primaryColors.lightPurple};
    gap: 40px;
    position: relative;

    h3 {
      font-weight: 500;
    }

    input[type="radio"] {
      display: none;
    }

    #testimonial1:checked ~ .slides .inner {
      margin-left: 0;
    }
    #testimonial2:checked ~ .slides .inner {
      margin-left: -200%;
    }
    #testimonial3:checked ~ .slides .inner {
      margin-left: -300%;
    }
    #testimonial4:checked ~ .slides .inner {
      margin-left: -400%;
    }
    #testimonial5:checked ~ .slides .inner {
      margin-left: -6400px;
    }

    .slides {
      z-index: 1;
      height: auto;
      overflow: hidden;

      .overflow {
        overflow: auto;
        position: relative;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .inner {
          transition: ${(props) => props.theme.transition};
          min-width: 100%;
          height: 270px;
          gap: 32px;
          flex-basis: auto;
          margin-bottom: 2px;

          .slide {
            min-width: 653px;
            max-width: 653px;
            flex: 1 653px;
            background-color: transparent;
            border-radius: 10px;
            border: 1px solid ${(props) => props.theme.color.primaryColors.white};
            gap: 16px;
            padding: 15px 20px;
            flex-grow: 1;

            .slideInnerCard {
              gap: 24px;
            }

            .testemonialLogoWrapper {
              height: auto;
              .logoContain {
                height: auto;
                border-radius: 5px;
                width: auto;
                background-color: ${(props) => props.theme.color.primaryColors.lighterPurple};
                padding: 12px 24px;

                p {
                  color: ${(props) => props.theme.color.primaryColors.fontColor};
                }

                &.candidate {
                  background-color: ${(props) => props.theme.color.primaryColors.labelPurple};
                  p {
                    color: ${(props) => props.theme.color.primaryColors.white};
                  }
                }
              }
            }

            .testemonialText {
              gap: 24px;
              min-width: 70%;

              p {
                color: ${(props) => props.theme.color.primaryColors.darkPurple};
                opacity: 0.8;
              }

              .clientName {
                color: ${(props) => props.theme.color.primaryColors.fontColor};
                font-weight: 600;
                text-transform: uppercase;
              }
            }
          }
        }
      }
    }

    #testimonial1:checked ~ .sliderDotsContainer .sliderDot:first-child {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial2:checked ~ .sliderDotsContainer .sliderDot:nth-child(2) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial3:checked ~ .sliderDotsContainer .sliderDot:nth-child(3) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial4:checked ~ .sliderDotsContainer .sliderDot:nth-child(4) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial5:checked ~ .sliderDotsContainer .sliderDot:nth-child(5) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial6:checked ~ .sliderDotsContainer .sliderDot:nth-child(6) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }
    #testimonial7:checked ~ .sliderDotsContainer .sliderDot:nth-child(7) {
      background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }

    .sliderDotsContainer {
      position: absolute;
      display: none;
      width: auto;
      bottom: calc(50% - 20px);
      height: auto;
      position: absolute;
      text-align: center;
      z-index: 3;
      left: calc(50% - 50px);
      bottom: 17px;
      gap: 40px;
      flex-shrink: 0;

      .sliderDot {
        width: 11px;
        height: 11px;
        margin: 0;
        margin: 5px;
        padding: 0;
        position: relative;
        border-radius: 100%;
        display: inline-block;
        background-color: ${(props) => props.theme.color.primaryColors.white};
        cursor: pointer;
      }
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    .purpleBlock {
      padding: 32px 50px 32px 50px;
      .slides {
        .overflow {
          .inner {
            height: 235px;
            .slide {
              max-width: 450px;
              min-width: 450px;

              .testemonialLogoWrapper {
                .logoContain {
                  padding: 8px 20px;
                  border-radius: 5px;
                }
              }
            }
          }
        }
      }
      .sliderDotsContainer {
        gap: 32px;
        bottom: 20px;

        .sliderDot {
          width: 8px;
          height: 8px;
        }
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    .purpleBlock {
      padding: 32px 30px 32px 30px;
      .slides {
        .overflow {
          .inner {
            height: 226px;
            .slide {
              max-width: 400px;
              min-width: 400px;
              border-radius: 5px;

              .testemonialLogoWrapper {
                .logoContain {
                  padding: 6px 12px;
                }
              }
            }
          }
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    .purpleBlock {
      padding: 32px 20px 32px 20px;

      .slides {
        .overflow {
          .inner {
            height: 236px;
            gap: 16px;

            .slide {
              max-width: 300px;
              min-width: 300px;
            }
          }
        }
      }
    }
  }
  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .purpleBlock {
      .slides {
        .overflow {
          .inner {
            gap: 16px;
            height: 271px;

            .slide {
              max-width: 300px;
              min-width: 300px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 390px) {
    .purpleBlock {
      padding: 24px 16px;
      gap: 24px;
    }
  }
`;

export default class ClientTestimonials extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.sliderRef = React.createRef();
  }

  getDefaultState = () => {
    return {
      ...this.getDefaultResultsState(),
    };
  };

  getDefaultResultsState = () => {
    return {
      interval: null,
      mouseDown: null,
      startX: null,
      scrollLeft: null,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    this.startSlide();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.stopSlide();
  }

  startSlide = () => {
    this.setState({
      interval: setInterval(this.slide, 120),
      mouseDown: false,
    });
  };

  stopSlide = () => {
    clearInterval(this.state.interval);
  };

  slide = () => {
    if (this.sliderRef.current.scrollLeft === this.sliderRef.current.scrollWidth - this.sliderRef.current.offsetWidth) {
      this.sliderRef.current.scrollTo({
        left: 0,
      });
    }
    this.sliderRef.current.scrollBy({
      left: 3,
      behavior: "smooth",
    });
  };

  mouseDown = (e) => {
    this.setState({
      mouseDown: true,
      mouseMove: true,
      startX: e.pageX - this.sliderRef.current.offsetLeft,
      scrollLeft: this.sliderRef.current.scrollLeft,
    });
  };

  mouseUp = (e) => {
    this.setState({
      mouseDown: false,
    });
  };

  mouseMove = (e) => {
    e.preventDefault();
    if (!this.state.mouseDown) {
      return;
    }
    const x = e.pageX - this.sliderRef.current.offsetLeft;
    const scroll = x - this.state.startX;
    this.sliderRef.current.scrollLeft = this.state.scrollLeft - scroll;
  };

  render() {
    return (
      <StyledClientTestimonials flexDirection="column" className="testimonialsBlock">
        <NanoFlex className="purpleBlock" flexDirection="column" alignItems="flex-start">
          <Type.h3>{this.translation.homepage.clientTestimonials.blockTitle}</Type.h3>

          <input type="radio" name="testimonialInputs" id="testimonial1" defaultChecked />
          <input type="radio" name="testimonialInputs" id="testimonial2" />
          <input type="radio" name="testimonialInputs" id="testimonial3" />
          <input type="radio" name="testimonialInputs" id="testimonial4" />
          <input type="radio" name="testimonialInputs" id="testimonial5" />

          <NanoFlex className="slides">
            <NanoFlex className="overflow" ref={this.sliderRef} onMouseEnter={() => this.stopSlide()} onMouseLeave={() => this.startSlide()} onMouseMove={(e) => this.mouseMove(e)} onMouseDown={(e) => this.mouseDown(e)} onMouseUp={(e) => this.mouseUp(e)}>
              <NanoFlex className="inner" alignItems="flex-start" justifyContent="flex-start">
                <NanoFlex className="slide" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in-out">
                  <NanoFlex className="slideInnerCard" alignItems="flex-start" flexDirection="column">
                    <NanoFlex className="testemonialLogoWrapper" justifyContent="flex-start">
                      <NanoFlex className="logoContain">
                        <Type.p>{this.translation.homepage.clientTestimonials.client}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="testemonialText" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                      <Type.p>“{this.translation.homepage.clientTestimonials.feedbackOne}"</Type.p>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="slide" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in-out">
                  <NanoFlex className="slideInnerCard" alignItems="flex-start" flexDirection="column">
                    <NanoFlex className="testemonialLogoWrapper" justifyContent="flex-start">
                      <NanoFlex className="logoContain candidate">
                        <Type.p>{this.translation.homepage.clientTestimonials.candidate}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="testemonialText" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                      <Type.p>“{this.translation.homepage.clientTestimonials.feedbackTwo}”</Type.p>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="slide" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in-out">
                  <NanoFlex className="slideInnerCard" alignItems="flex-start" flexDirection="column">
                    <NanoFlex className="testemonialLogoWrapper" justifyContent="flex-start">
                      <NanoFlex className="logoContain">
                        <Type.p>{this.translation.homepage.clientTestimonials.client}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="testemonialText" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                      <Type.p>“{this.translation.homepage.clientTestimonials.feedbackThree}”</Type.p>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="slide" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in-out">
                  <NanoFlex className="slideInnerCard" alignItems="flex-start" flexDirection="column">
                    <NanoFlex className="testemonialLogoWrapper" justifyContent="flex-start">
                      <NanoFlex className="logoContain candidate">
                        <Type.p>{this.translation.homepage.clientTestimonials.candidate}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="testemonialText" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                      <Type.p>“{this.translation.homepage.clientTestimonials.feedbackFour}”</Type.p>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="slide" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in-out">
                  <NanoFlex className="slideInnerCard" alignItems="flex-start" flexDirection="column">
                    <NanoFlex className="testemonialLogoWrapper" justifyContent="flex-start">
                      <NanoFlex className="logoContain candidate">
                        <Type.p>{this.translation.homepage.clientTestimonials.candidate}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="testemonialText" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                      <Type.p>“{this.translation.homepage.clientTestimonials.feedbackFive}”</Type.p>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="sliderDotsContainer">
            <label className="sliderDot" for="testimonial1"></label>
            <label className="sliderDot" for="testimonial2"></label>
            <label className="sliderDot" for="testimonial3"></label>
          </NanoFlex>
        </NanoFlex>
      </StyledClientTestimonials>
    );
  }
}
